import { useQuery } from "@tanstack/react-query";

import { useScopeParams } from "@/hooks/useScopeParams";
import { apiFetchJson } from "@/utils/apiFetch";

export type InvestigatorSite = {
  site_key: string;
  site_name: string | null;
  lat: number | null;
  lon: number | null;
  city: string | null;
  country_code: string | null;
  trial_count: number;
  trial_ids: string[];
  /** Resolvable golden institution id, or null when no site profile exists. */
  institution_id: string | null;
};

export function useInvestigatorSitesQuery(invKey: string | undefined) {
  const { scope, id } = useScopeParams();

  return useQuery<InvestigatorSite[]>({
    queryKey: ["investigator-sites", scope, id, invKey],
    queryFn: () =>
      apiFetchJson<InvestigatorSite[]>(
        `${import.meta.env.VITE_API_URL}/data/portfolio/investigator-sites/${encodeURIComponent(invKey!)}/`,
      ),
    enabled: !!scope && !!id && !!invKey,
    staleTime: 5 * 60 * 1000,
  });
}
